import { ApiError } from '@/lib/api/errors';

export const FORM_ERROR = 'Please correct the errors below and submit the form again.';
export const GENERIC_ERROR = 'There was an error contacting the API. Please try again.';
export const SESSION_EXPIRED = 'Your session has expired. Please sign in again to continue.';

/** Text to show for a failed request: the service's title when it gave one. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  return GENERIC_ERROR;
}
